module.exports = __webpack_public_path__ + "static/img/res-kuang-poster.7e6f4e53.jpg";